import { Quote, Star } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { REVIEWS } from "@/data/content";

const Recensioni = () => (
  <section id="recensioni" data-testid="recensioni-section" className="bg-beige py-24 sm:py-36">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHeading
        chapter="07"
        eyebrow="Recensioni"
        title="La voce delle famiglie"
        text="Le testimonianze di chi ci ha affidato una persona cara."
        testid="recensioni-heading"
        hint="recensioni-scroll-hint"
      />
      <div className="mt-8 flex touch-pan-x snap-x snap-mandatory gap-4 overflow-x-auto pb-4 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden lg:mt-16 lg:touch-auto lg:grid lg:grid-cols-3 lg:gap-6 lg:overflow-visible lg:pb-0">
        {REVIEWS.map((r, i) => (
          <Reveal key={r.author} delay={i * 0.12} className="w-[85%] shrink-0 snap-start lg:w-auto">
            <figure
              data-testid={`review-card-${i}`}
              className="flex h-full flex-col rounded-[2rem] bg-ivory p-8 transition-all duration-500 hover:-translate-y-1 hover:shadow-xl hover:shadow-sage/10"
            >
              <Quote size={28} className="text-terracotta/60" />
              <div className="mt-4 flex gap-1" aria-label="5 stelle">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} size={15} className="fill-terracotta text-terracotta" />
                ))}
              </div>
              <blockquote className="mt-4 flex-1 font-serif text-lg italic leading-relaxed text-ink/90">“{r.text}”</blockquote>
              <figcaption className="mt-6 border-t border-sand pt-4">
                <p className="text-sm font-semibold text-ink">{r.author}</p>
                <p className="text-xs text-moss">{r.role}</p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Recensioni;
